import RoomSelectViewPortrait from "../../views/RoomSelectViewPortrait";
import TypeSelectViewPortrait from "../../views/TypeSelectViewPortrait";
import MainViewPortrait from "../../views/MainViewPortrait";
import PaytableWinPortrait from "../../views/PaytableWinPortrait";


class GameFactoryPortrait
{
    getRoomSelectView()
    {
        return RoomSelectViewPortrait;
    }

    getTypeSelectView()
    {
        return TypeSelectViewPortrait;
    }

    getMainView()
    {
        return MainViewPortrait;
    }

    getPaytable()
    {
        return new PaytableWinPortrait();
    }
}

export default GameFactoryPortrait;